import { useContext, useEffect } from "react";
import styles from "./InteractionPeople.module.scss";
import clapImg from "../../../../../../assets/images/icons/clap.png";
import thinkImg from "../../../../../../assets/images/icons/think.png";
import thoughtImg from "../../../../../../assets/images/icons/thought.png";
import { EMOJI_NAMES } from "../../InteractionContainer";
import { UserContext } from "../../../../../../contexts/UserContext/UserContextProvider";
import { networkContext } from "../../../../../../contexts/NetworkContext/NetworkContextProvider";
import UserManager from "../../../../../../Managers/Users";

const TIME = 10;

const getEmoji = (type) => {
  switch (type) {
    case EMOJI_NAMES.CURIOUS:
      return thoughtImg;
    case EMOJI_NAMES.AMAZING:
      return clapImg;
    case EMOJI_NAMES.THINKING:
      return thinkImg;
    default:
      return "";
  }
};

const InteractionPeople = ({
  id,
  item: { name, timestamp, image, type, userId },
  timeUp,
  webinarId,
}) => {
  const {
    user,
    isChatBotOpen,
    setIsChatBotOpen,
    chatSectionStatus,
    toggleChatSection,
  } = useContext(UserContext);
  const { openChat } = useContext(networkContext);

  useEffect(() => {
    let timeRun = 0;
    let time = setInterval(() => {
      timeRun++;
      if (timeRun === TIME) {
        timeUp(time, id);
      }
    }, 1000);

    // return () => {
    //   clearInterval(time);
    // };
  }, []);

  const handleConnectBtn = async () => {
    console.log("");
    if (userId) {
      await UserManager._get.getUser(userId).then((res) => {
        if (!isChatBotOpen) {
          setIsChatBotOpen(true);
          if (!chatSectionStatus) {
            toggleChatSection(true);
          }
        }
        openChat(webinarId, { ...res, id: res.userid });
      });
    }
  };

  return (
    <div className={styles.imgContainer}>
      {/* <img className={styles.img} src={image || ""} alt="" /> */}
      {/* <div className={styles.namedProfileIcon}>{`${
        name.firstName ? name.firstName.charAt(0).toUpperCase() : ""
      } ${name.lastName ? name.lastName.charAt(0).toUpperCase() : ""}`}</div> */}
      <div className={styles.namedProfileIcon}>{`${name
        ?.split(" ")[0]
        .charAt(0)
        .toUpperCase()} ${name?.split(" ")[1].charAt(0).toUpperCase()}`}</div>
      <div className={styles.interaction}>
        <img className={styles.img} src={getEmoji(type)} alt="" />
      </div>
      {user.uid !== userId && (
        <div className={styles.connectPeople}>
          <div className={styles.name}>{name}</div>
          <div className={styles.connect} onClick={handleConnectBtn}>
            Connect
          </div>
        </div>
      )}
    </div>
  );
};

export default InteractionPeople;
